var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.showFooter)?_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer-content"},[_c('p',{staticClass:"footer-text"},[_vm._v(_vm._s(_vm.footerText))])])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }